import { render } from "./index.vue?vue&type=template&id=020627ce"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=020627ce&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script